import scroll from './scroll';

const modal = {
    open: false,

    init() {


        // alert("--");
        // $(document).on("click", "._open_modal_abo", function () {
        //     alert("click");
        // });

        $(document).on("click", "._open_modal", function () {
            var _modal = $(this).data("modal");
            $(_modal).addClass("_show");
            $("html,body").addClass("_no_overflow");
        });

        $(document).on("click", "._open_contact", function () {
            $(".__modal.__contact").addClass("_show");
            $("html,body").addClass("_no_overflow");
        });

        $(document).on("click", ".__close_modal,.__btn_close_modal", function () {
            $(".__modal").removeClass("_show");
            $(".block-hide").hide();
            $(".__choice").show();
            $("html,body").removeClass("_no_overflow");
        });

        $(document).on("click", ".__list_select", function () {
            const $select = $(this);
            $select.toggleClass("_open");

            const $container = $select.closest("._contain_input");
            const $options = $select.find("._options");
            const $trigger = $select.find(".__choice_value");

            // rendre visible temporairement pour mesurer
            $options.css({display: "block", visibility: "hidden"});
            const optionsHeight = $options.outerHeight();
            $options.css({display: "", visibility: ""});

            const rect = $trigger[0].getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;

            if (spaceBelow < optionsHeight && spaceAbove > optionsHeight) {
                $select.addClass("_top").attr("data-position", "top");
            } else {
                $select.removeClass("_top").attr("data-position", "bottom");
            }
        });

        $(document).on("click", "._options > span", function () {
            let _id = $(this).data("id");
            let _txt = $(this).html();
            $(".__choice_value > span").html(_txt);
            $("input[name=recall_type]").val(_id);
            $("input[name=contact_type]").val(_id);
        });

        // Ajout de la mise en forme automatique des numéros de téléphone
        $(document).on("input", "input[type=phone]", function (e) {
            let value = e.target.value.replace(/\D/g, ''); // Supprimer tout sauf les chiffres
            let formattedValue = '';

            // Formatage des groupes de deux chiffres
            for (let i = 0; i < value.length; i += 2) {
                if (i > 0 && i < 10) { // Ajoute un espace après chaque deux chiffres sauf après le dernier groupe
                    formattedValue += ' ';
                }
                formattedValue += value.substring(i, i + 2);
            }

            e.target.value = formattedValue.substring(0, 14); // Limiter à 14 caractères
        });
    }
};

export default modal;
